document.addEventListener('DOMContentLoaded', function () {
  const addTypeProduct = (form) => {
    if (!form || form.tagName !== 'FORM') return;
    if (!form.action || !form.action.includes('/search')) return;
    if (!form.querySelector('input[name="type"]')) {
      const i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'type';
      i.value = 'product';
      form.appendChild(i);
    }
  };

  // Add to all existing search forms
  document.querySelectorAll('form[action*="/search"]').forEach(addTypeProduct);

  // Safety: ensure submit keeps it
  document.addEventListener('submit', function (e) {
    const f = e.target;
    if (f && f.tagName === 'FORM' && f.action && f.action.includes('/search')) {
      if (!f.querySelector('input[name="type"]')) {
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'type';
        i.value = 'product';
        f.appendChild(i);
      }
    }
  });

  // In case the header loads forms later (Ajax/predictive), watch and patch
  const mo = new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) {
          if (n.matches && n.matches('form[action*="/search"]')) addTypeProduct(n);
          n.querySelectorAll && n.querySelectorAll('form[action*="/search"]').forEach(addTypeProduct);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
});
